export default {
  section: {
    width: '100%'
  },
  titleContainer: {
    width: '100%',
    maxWidth: '1530px'
  },
  column: (isMobile: boolean) => ({
    position: 'relative',
    ':not(.row__column--paddingless)': {
      padding: isMobile ? `8px 0` : ''
    },
    '::before': theme => ({
      content: '""',
      width: '100%',
      position: 'absolute',
      height: 1,
      opacity: 1,
      background: theme.rawColors.lightGrey300
    })
  }),
  productsRow: {
    width: '100%',
    pt: '40px',
    // override bootstrap link style from simple configurator
    '.vox-row__column': {
      'a:hover': {
        textDecoration: 'none !important'
      }
    }
  },
  loader: {
    position: 'relative',
    width: '100%',
    height: '200px',
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px']
  }
};